import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';
import { getThemeColor } from '../../../../utils/styleUtils';

export const StyledCard = styled(Card)(
  ({ backgroundColor, theme, padding }) => ({
    maxWidth: '400px',
    ...(padding ? { padding: padding } : {}),
    borderRadius: 0,
    ...(backgroundColor
      ? { backgroundColor: getThemeColor(backgroundColor, theme) }
      : {}),
  }),
);
